import Divider from "components/ui/divider"
import Image from "components/ui/image"
import Shimmer from "components/ui/shimmer"

import { GridContainer } from "../products"
import ItemContainer from "../products/item-container"

const ShimmersPortal = () => (
  <div className="contained-wide px-16">
    <div className="flex justify-end">
      <Shimmer
        className="w-(--base-width) desktop:w-(--desktop-width) mt-16"
        style={{
          "--base-width": "40px",
          "--desktop-width": "100px",
          height: "12px",
        }}
      />
    </div>
    <div className="mx-8 my-16 py-16">
      <Shimmer className="mb-16" style={{ height: "17px", width: "150px" }} />
      <div className="flex justify-between">
        <div className="desktop:w-3/4">
          <Shimmer
            className="w-(--base-width) desktop:w-(--desktop-width) desktop:h-(--desktop-height) h-(--base-height)"
            style={{
              "--base-height": "12px",
              "--base-width": "300px",
              "--desktop-height": "20px",
              "--desktop-width": "600px",
            }}
          />
        </div>
      </div>
    </div>
    <Divider className="bg-grey-10 tablet:block hidden" />
    <div className="flex justify-center">
      <div className="flex-1">
        <GridContainer>
          {[...Array(12)].map((_, i) => (
            <ItemContainer key={`shimmerplacholder${i}`}>
              <Shimmer
                className="tablet:w-(--tablet-width) widescreen:w-(--widescreen-width) w-full"
                style={{
                  "--tablet-width": "256px",
                  "--widescreen-width": "300px",
                }}
              >
                <Image
                  alt=""
                  className="w-full"
                  height="1024"
                  src={require(
                    `images/collections/placeholder_masks/ring_${(i % 6) + 1}.svg`
                  )}
                  width="1024"
                />
              </Shimmer>
            </ItemContainer>
          ))}
        </GridContainer>
      </div>
    </div>
  </div>
)

export default ShimmersPortal
